<script>
import Vue from 'vue';

export default {
  name: 'base-table',
  props: {
    tableColumn: {
      type: [Array],
      default: function() {
        return [];
      }
    },
    data: {
      type: [Array],
      default: () => []
    },
    //已经查看过的任务id【需要高亮】
    highLightItem: {
      type: [String, Number],
      default: ''
    },
    defaultSort: {
      type: [Object],
      default: () => ({})
    },
    checkData: {
      // 是否检测数据是否存在，不存在提示 不存在**字段
      type: Boolean,
      default: true
    }
  },
  computed: {
    indeterminate() {
      const [selectionCol] = this.tableColumn.filter(
        i => i.type === 'selection'
      );
      // 可选择的项
      const canSelectList = this.data.filter(item => {
        return !selectionCol.disabled(item);
      });
      return (
        this.selection.length > 0 &&
        this.selection.length < canSelectList.length
      );
    },
    columnNoType() {
      return this.tableColumn.filter(i => !i.type);
    },
    tableColumnSelection() {
      return this.tableColumn.find(i => i.type === 'selection');
    },
    selection() {
      return this.data.filter(i => +i.isSelected === 1) || [];
    }
  },
  methods: {
    tableRowStyle({ row }) {
      if (this.highLightItem === row.taskId) {
        return {
          'background-color': '#fffaf1'
        };
      }
      return '';
    },
    // columns初始化后
    columnsDone() {
      // 执行默认排序，因colums初始化是异步操作，所以需要手动添加排序，el-table内defaultSort属性无效
      this.$refs.elTable.columns.forEach(col => {
        if (col.property === this.defaultSort.prop) {
          col.order = this.defaultSort.order;
        }
      });
    }
  },
  render(h) {
    return h(
      'el-table',
      {
        class: 'v2-base-table',
        props: {
          data: this.data,
          border: true,
          height: '80vh',
          'row-style': this.tableRowStyle,
          ...this.$attrs
        },
        ref: 'elTable',
        on: {
          'sort-change': e => {
            this.$listeners['sort-change'](e);
          }
        }
      },
      this.tableColumn
        .filter(col => !col.hidden) // 添加hidden属性，存在则不渲染
        .map(col => {
          const _this = this;
          if (col.type == 'index' && col.render === undefined) {
            return h('el-table-column', {
              props: { ...col }
            });
          }
          // 自定义 选择
          if (col.type == 'selection') {
            return h('el-table-column', {
              props: {
                width: '50',
                fixed: col.fixed,
                resizable: col.resizable
              },
              scopedSlots: {
                default: props => {
                  const { row } = props;
                  Vue.util.defineReactive(row, 'isSelected');
                  return h('el-checkbox', {
                    props: {
                      value: row.isSelected == '1',
                      disabled: col.disabled && col.disabled(row)
                    },
                    on: {
                      input: function(v) {
                        col
                          .inputChange(v, row)
                          .then(() => {
                            row.isSelected = v ? '1' : '0';
                          })
                          .catch(() => {
                            _this.$message.error('错误', '服务器错误');
                          });
                      }
                    }
                  });
                },
                header: () => {
                  return h('el-checkbox', {
                    props: {
                      disabled: !_this.data.length,
                      value: _this.selection.length > 0,
                      indeterminate: _this.indeterminate
                    },
                    on: {
                      change: function(e) {
                        e = _this.indeterminate ? true : e;
                        // 可选择的项
                        const canSelectList = _this.data.filter(item => {
                          return !col.disabled(item);
                        });
                        _this.selection.length === canSelectList.length &&
                          (e = false);
                        _this.$emit('select-all', e);
                      }
                    }
                  });
                }
              }
            });
          }
          if (col.type === 'sortable') {
            return h('el-table-column', {
              props: {
                label: col.label,
                prop: col.prop,
                sortable: col.sortable,
                resizable: col.resizable,
                align: 'center',
                width: col.width || ''
              },
              scopedSlots: {
                default: props => {
                  const { row } = props;
                  const { formatter, render } = col;
                  // 行数据存在对应字段
                  let val = row[col.prop];

                  return render
                    ? render(
                        h,
                        { scope: props, row, col, cellValue: val },
                        _this.$parent
                      )
                    : formatter
                    ? h('span', formatter({ val, row }) || '-')
                    : h('span', val || typeof val == 'number' ? val : '-');
                }
              }
            });
          }
          // 普通列
          return h('el-table-column', {
            props: {
              label: typeof col.label === 'function' ? col.label() : col.label,
              prop: col.prop,
              width: col.width || '',
              fixed: col.fixed,
              resizable: col.resizable,
              align: 'center',
              'show-overflow-tooltip': col.tooltip === false ? false : true
            },
            scopedSlots: {
              default: props => {
                const { row } = props;
                const { formatter, render } = col;
                // 不需要验证 字段值的情况 ，比如合同详情列 都是 ’详情‘
                if (col.prop === '' || col.prop === undefined) {
                  if (!render && !col.type) {
                    throw new Error(
                      `表格props tableColumn 的 数据项 ${col.label} prop 如果为空 ，需要render`
                    );
                  }
                  return render(h, { scope: props, row, col }, _this.$parent);
                }
                if (_this.checkData && !(col.prop in row)) {
                  return h('span', `不存在 ${col.prop} 字段`);
                }

                // 行数据存在对应字段
                let val = row[col.prop];

                return render
                  ? render(
                      h,
                      { scope: props, row, col, cellValue: val },
                      _this.$parent
                    )
                  : formatter
                  ? h('span', formatter({ val, row }) || '-')
                  : h('span', val || typeof val == 'number' ? val : '-');
              }
            }
          });
        })
    );
  },
  mounted() {
    //解决放大缩小页面时表格错位问题
    const _this = this;
    window.onresize = () => {
      _this.$nextTick(() => {
        setTimeout(() => {
          try {
            _this.$refs.elTable.doLayout();
          } catch (error) {}
        });
      });
    };
  },
  updated() {
    let resizeFn = this.$refs.elTable.resizeListener;
    typeof resizeFn === 'function' && resizeFn();
  }
};
</script>
<style>
.v2-base-table thead {
  border-radius: 5px 5px 0 0;
  position: relative;
}
.v2-base-table thead tr th {
  border: 0.5px solid;
  background: transparent !important;
}
.v2-base-table thead tr th:not(:last-child) {
  border-color: #a3d0fd #a3d0fd transparent transparent;
}
.v2-base-table thead tr th:first-child {
  border-color: #a3d0fd #a3d0fd transparent #a3d0fd;
}
.v2-base-table thead tr th:last-child {
  border-color: #a3d0fd transparent transparent transparent;
}
.v2-base-table thead tr {
  background-color: #e6f1fc !important;
}
</style>
<style scoped>
>>> .el-table__fixed-right-patch {
  border: 0.5px solid !important;
  border-color: #a3d0fd #a3d0fd transparent transparent !important;
  background-color: #e6f1fc !important;
  top: 0 !important;
  right: 1px !important;
}
body .el-table th.gutter {
  display: table-cell !important;
}
</style>
